export default {
  1: "آذربایجان شرقی",
  2: "آذربایجان غربی",
  3: "اردبیل",
  4: "اصفهان",
  5: "البرز",
  6: "ایلام",
  7: "بوشهر",
  8: "تهران",
  9: "خراسان جنوبی",
  10: "خراسان رضوی",
  11: "خراسان شمالی",
  12: "خوزستان",
  13: "زنجان",
  14: "سمنان",
  15: "سیستان و بلوچستان",
  16: "فارس",
  17: "قزوین",
  18: "قم",
  19: "کردستان",
  20: "کرمان",
  21: "کرمانشاه",
  22: "کهگیلویه وبویراحمد",
  23: "لرستان",
  24: "مازندران",
  25: "مرکزی",
  26: "هرمزگان",
  27: "همدان",
  28: "چهارمحال بختیاری",
  29: "گلستان",
  30: "گیلان",
  31: "یزد",
};
